export default __webpack_public_path__ + "static/media/sav-logo.862a13e2.png";